import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DeleteProjectAPI, GetAllProjectByOpportunity, GetAllProjectsAPI, GetProjectsOpportunityPanelsByOpportunityAPI, } from "../../../API/ProjectsAPI";
import useModal from "../../../Hooks/useModal";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { ProjectModel, ProjectsWithProjectGroupingModel } from "../../../Models/ProjectModel";
import { EnumType, ProjectColumns } from "../../../Static/ProjectColumns";
import ModalProject from "../../ModalProject";
import PaginationTabs from "../../Shared/PaginationTabs";
import TableDefaultProjectInformation from "../../Shared/TableDefaultProjectInformation";
import ModalValuesComponent from "../ModalValuesComponent";
import './styles.css';
import { OpportunitiesPanelsModel } from "../../../Models/OpportunitiesPanelsModel";
import { ProjectGroupingModel } from "../../../Models/ProjectGroupingModel";
//import { Table } from "react-bootstrap";
import { formatDate } from "../../../Utils/DateFormat";
import { MdOutlineGroupWork } from "react-icons/md";
import { FaEye, FaPencilAlt, FaRegLightbulb, FaStopwatch, FaTrash } from "react-icons/fa";
import { CiCircleCheck, CiNoWaitingSign } from "react-icons/ci";
import { ExternalRoles } from '../../../Static/Roles';
import useCan from "../../../Hooks/useCan";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import TablePaginationFooter from "../../Shared/TableDefaultProjectInformation/Pagination";
import ModalProjectsProjectWithGrouping from "../../ModalProjectsProjectWithGrouping";
import { DeleteOutlined, EditOutlined, EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, notification, Space, Table, TableProps } from "antd";
import { ProjectWithGroupingAndPanel } from "../../../Models/projectwithGroupingAndPanel";


interface IProjectsComponentProps {
    companyId: string,
    toggleLoading: (data: boolean) => void,
    opportunityId: string,
    setHasChanged: React.Dispatch<React.SetStateAction<boolean>>,
    canNotEdit: boolean,
    setType: any,
}

const ProjectsComponent = (props: IProjectsComponentProps) => {
    const { showModal, toggleShowModal } = useModal();
    const { showModal: showModalProject, toggleShowModal: toggleShowModalProject } = useModal();
    const [pag, setPag] = useState<number>(0);
    const [key, setKey] = useState<number>(0);
    const [total, setTotal] = useState<number>(0);
    const [searchText, setSearchText] = useState<string>("");
    const [projects, setProjects] = useState<ProjectWithGroupingAndPanel[]>([]);
    const [projectWitNotPanel, setprojectWitNotPanel] = useState<ProjectsWithProjectGroupingModel[]>([]);
    const [project, setProject] = useState<ProjectModel>({} as ProjectModel);
    const [projectsOpportunityPanels, setProjectsOpportunityPanels] = useState<OpportunitiesPanelsModel[]>([] as OpportunitiesPanelsModel[]);
    const canNotView = useCan({ rolesCan: ["Internal", "TechnicianLimited", "Technician", "Dossie", "Financial"] });
    const ColumnWithButton = 2;
    const canNotDelete = useCan({ rolesCan: [...ExternalRoles] });
    const [itemToDelete, setItemToDelete] = useState<string>("");
    const [deleteResponse, setDeleteResponse] = useState<boolean>(false);
    const [filteredData, setFilteredData] = useState<ProjectWithGroupingAndPanel[]>([]);


    const navigate = useNavigate();
    const columns = ["Projetos Futuros", "Outros Investimentos"];

    const getAllProjects = async (page?: number) => {
        try {
            props.toggleLoading(true);
            let text = searchText == null || searchText == "" ? "all" : searchText;

            await GetAllProjectsAPI(props.opportunityId, pag, page ?? 1, 7, text).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setprojectWitNotPanel(resp.data.items)
                    setTotal(resp.data.total);
                    
                }
            }).finally(() => {
                props.toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }
    const getProjects = async () => {

        props.toggleLoading(true);
        await GetAllProjectByOpportunity(props.opportunityId).then((resp: ProjectWithGroupingAndPanel[]) => {
            const noDuplication = resp.filter((p , index, self)=> index === self.findIndex((x) => x.id === p.id))
            setProjects(noDuplication);
            setFilteredData(noDuplication);

        }).finally(() => {
            props.toggleLoading(false);
        });
    }


    const GetProjectsOpportunityPanelsByOpportunity = async () => {
        try {
            props.toggleLoading(true);

            await GetProjectsOpportunityPanelsByOpportunityAPI(props.opportunityId).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setProjectsOpportunityPanels(resp.data);

                }
            }).finally(() => {
                props.toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }

    const DeleteProject = async (projectId: string) => {
        try {
            props.toggleLoading(true);

            await DeleteProjectAPI(projectId, props.opportunityId, props.companyId).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    
                    toast.success("Projeto deletado com sucesso!");
                    if (pag == 0) {
                        getAllProjects();
                        props.setHasChanged(true);
                    } else {
                        getAllProjects();
                    }
                }
                setTimeout(() => {window.location.reload()}, 5000);
            }).finally(() => {
                props.toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }

    const navigateToCreate = () => {
        const route = `/projectInformation/createProject/${props.companyId}/${pag}/${props.opportunityId}`;

        navigate(route);
    }

    const showValuesOnModal = (project: ProjectModel) => {
        setProject(project);
        toggleShowModal()
    }

    const setModalProject = (project: ProjectModel) => {
        setProject(project);
    }

    useEffect(() => {
        getProjects();
    }, []);

    useEffect(() => {
        GetProjectsOpportunityPanelsByOpportunity();
    }, [props.opportunityId]);

    useEffect(() => {
        getAllProjects();
        props.setType(pag);
    }, [pag, props.opportunityId]);

    useEffect(() => {
        if (deleteResponse && itemToDelete !== "") {
            if (DeleteProject) {
                DeleteProject(itemToDelete);
            }
            setItemToDelete("");
            setDeleteResponse(false);
        } else if (itemToDelete != "") {
            setItemToDelete("");
        }
    }, [deleteResponse]);

    const columnsProject: TableProps<ProjectWithGroupingAndPanel>['columns'] = [
        {
            key: "projectName",
            dataIndex: "projectName",
            showSorterTooltip: { target: 'full-header' },
            filters: projects.map(item => ({
                text: item.projectName,
                value: item.projectName,
            })),
            onFilter: (value, record) => record.projectName.indexOf(value as string) === 0,
            title: "Nome do Projeto",

        },
        {
            title: "Orçamento Estimado",
            dataIndex: "budget",
            key: "budget",
            render: (text: number) => `R$ ${text.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
        },
        {
            title: "elegibilidade",
            dataIndex: "eligibilityType",
            key: "eligibilityType",
            render: (_: any, record: ProjectWithGroupingAndPanel) => (
                <div>{record.eligibilityType == "eligible" ?
                    <p>Elegível</p>
                    : record.eligibilityType == "notEligible" ?
                        <p>Não Elegível</p>
                        : record.eligibilityType == "maybe" ?
                            <p>Talvez</p>
                            : <p>Pendente</p>}
                </div>
            ),
        },
        {
            title: "Agrupamento",
            dataIndex: "groupName",
            key: "groupName",
        },
        {
            title: "Mapeamento",
            dataIndex: "oportunityName",
            key: "oportunityName",
        },
        {
            title: "Ações",
            key: "actions",
            render: (_: any, record: ProjectWithGroupingAndPanel) => (
                <Space>
                    <div className='d-flex align-items-center justify-content-center'>
                            <><Link to={`/projectInformation/editProject/` + record.id}>
                                <EditOutlined className="cursor-pointer me-3" style={{ color: 'blue' }} />
                            </Link><button type="button" onClick={() => { changeToProjectModel(record.id); toggleShowModalProject(); }} className='btn p-0'>
                                    <EyeOutlined className="cursor-pointer me-3" style={{ color: 'blue' }} />
                                </button>
                                {(!canNotDelete) &&
                            <button type="button" onClick={() => { DeleteProject(record.id); toggleShowModal() }} className='btn p-0'>
                                <DeleteOutlined style={{ color: 'red' }} className="cursor-pointer" />
                            </button>
                            }
                            </>
                    </div>
                </Space>
            ),
        },
    ];
    function  changeToProjectModel(projectid: string){
    projectWitNotPanel.forEach(element => {
        if(projectid.toLowerCase === element.project.id.toLowerCase){
            console.log("cai aqui: ", element.project)
            setModalProject(element.project)
            
        }
        
    });

    }
    

    return (
        <div className="mt-4">
            {project.id && <ModalValuesComponent show={showModal} toggleShow={toggleShowModal} project={project} />}
            <ModalProjectsProjectWithGrouping
                showModal={showModalProject}
                toggleShowModal={toggleShowModalProject}
                projectItem={project}
            />
            <PaginationTabs setPag={setPag} pag={pag} setKey={setKey} keyDefault={key} tabs={columns} />
            <div className="container-table">

                <Table
                    columns={columnsProject}
                    dataSource={filteredData}
                    rowKey="id"
                    pagination={{
                        pageSize: 5,
                        showSizeChanger: true,
                        pageSizeOptions: ["5", "10", "15"],
                    }}
                />
            </div>
                {!props.canNotEdit &&
                    <Button 
                        type="primary"
                        style={{
                            width: '70%', 
                            float: 'right',
                            fontWeight: "bold",
                            margin: "10px 0px 20px 10px"
                        }}
                        onClick={navigateToCreate}
                    >
                        Criar {columns[pag]}
                    </Button>
                }
            </div>     
    )
}

export default ProjectsComponent;